module.exports = __webpack_public_path__ + "static/media/22ESCWA17.a870b7b7.jpg";